import React, { useEffect, useState } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import { selectUser } from "../../services/store/userSlice";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import MyLeaveDashboard from "./my-leave-dashboard";
import ManagerDashboard from "./manager-dashboard";
import ResourceCalendar from "./views/resource-calendar";
import EventCalendar from "./views/event-calendar";
import { hasPermission } from "../../components/protected/ProtectedSection";
import { LEAVES_ADMIN, LEAVES_ADMIN_REGION_MAP } from "../../config/permissions";
import { UserMaintenance } from "../extentions/user-management/user/userMaintenance";

const Leaves = () => {
  const user = useSelector(selectUser);
  const navigate = useNavigate();
  const [isEmployee, setIsEmployee] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [regionAdminKey, setRegionAdminKey] = useState(null);
  const [absenceData, setAbsenceData] = useState(null);
  const [calendarData, setCalendarData] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    setIsEmployee(user.roles.includes("manager"));
    setIsAdmin(hasPermission(LEAVES_ADMIN));
    const matchedRegionKey = Object.keys(LEAVES_ADMIN_REGION_MAP).find((key) =>
      hasPermission(LEAVES_ADMIN_REGION_MAP[key].permission),
    );
    setRegionAdminKey(matchedRegionKey || null);
  }, []);

  useEffect(() => {
    try {
      const data = localStorage.getItem("absenceData");
      if (data) {
        setAbsenceData(JSON.parse(data));
        navigate("/leaves/new-absence");
      } else {
        setAbsenceData(null);
      }
    } catch (error) {
      setAbsenceData(null);
    }
  }, [localStorage.getItem("attendanceData")]);

  useEffect(() => {
    try {
      const data = localStorage.getItem("clickedDate");
      if (data) {
        setCalendarData(JSON.parse(data));
      } else {
        setCalendarData(null);
      }
    } catch (error) {
      setCalendarData(null);
    }
  }, [localStorage.getItem("clickedDate")]);

  return (
    <div className="">
      <div className="">
        <TabView
          activeIndex={activeIndex}
          onTabChange={(e) => setActiveIndex(e.index)}
        >
          <TabPanel header="My Leave">
            {" "}
            <MyLeaveDashboard />
          </TabPanel>
          {isEmployee && (
            <TabPanel header="Team Leave">
              <ManagerDashboard />
            </TabPanel>
          )}
          <TabPanel header="My Calendar">
            <ResourceCalendar />
          </TabPanel>
          <TabPanel header="Holiday Calendar">
            <EventCalendar />
          </TabPanel>
          {isAdmin && (
            <TabPanel header="Users">
              <UserMaintenance limitFor="LEAVES_ADMIN" />
            </TabPanel>
          )}
          {regionAdminKey && (
            <TabPanel header={`Users (${LEAVES_ADMIN_REGION_MAP[regionAdminKey].locationCode})`}>
              <UserMaintenance limitFor={regionAdminKey} />
            </TabPanel>
          )}
        </TabView>
      </div>
    </div>
  );
};
export default Leaves;